import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/w/signing-requests')({
  staticData: {
    breadcrumb: 'Signing Requests',
    breadcrumbKey: 'K_BREADCRUMB_SIGNING_REQUESTS',
  },
  component: SigningRequestsLayout,
});

function SigningRequestsLayout() {
  return <Outlet />;
}
